module.exports = __webpack_public_path__ + "edd2fe763b29ce12f83d40f4ba2146af.pdf";